import * as ngCore from '@angular/core'

/**
 * Used to open the writing assistant
 */
@ngCore.Component({
  selector: 'atn-platform-writing-helper-handle',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {}
